'use strict';

      // -------------------------------------------//
     //               Transform Request for Api               //
    // -------------------------------------------//
function transformPropertiesForApi(list)
{
  for(var key in list)
  {

    if(list.hasOwnProperty(key))
    {
      if(typeof list[key] == 'object')
      {
        transformPropertiesForApi(list[key]);
      }
      if(key.indexOf('++') >= 0)
      {
        //console.log(key);
        //key.replace('++','$');
        var old_key = key;
        var new_key = key.replace('++','$');
        if (old_key !== new_key) {
            Object.defineProperty( list, key.replace('++','$'),
            Object.getOwnPropertyDescriptor(list, key));
            delete list[key];
        }
      }
    }

  }
}


      // -------------------------------------------//
     //               Clear Array                  //
    // -------------------------------------------//

function d(value , level, type)
{
  if(conf_appMode == 'debug')
  {
    var prestring = null;
    if(type == undefined)
    {
      type = 1;
    }
    if(level != undefined && typeof level == 'number' && level > 0)
    {
      prestring = '';
      for(var i = 0; i < level; i++)
      {
        prestring = prestring + '-';
      }
      prestring = prestring + '› ';
    }
    if(prestring == null)
    {

    }else{

    }
    switch(type)
    {
      case 1:
       // console.log((prestring == null) ? value : prestring + value);
      break;
      case 2:
        console.info((prestring == null) ? value : prestring + value);
      break;
      default:
       // console.log((prestring == null) ? value : prestring + value);
    }
  }

}
function _d(value , level, type)
{
  d(value , level, type)
}
Array.prototype.unique = function(fn) {
    var a = this.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i] === a[j])
               // fn(a[i],a[j]);
                a.splice(j--, 1);
        }
    }

    return a;
};
Array.prototype.compact = function() {
  return this.filter(function(x) {
    return x !== null && x !== undefined;
  });
};

Array.prototype.inArray = function( needle ){

    return Array(this).join(",").indexOf(needle) >-1;

};

Array.prototype.clear = function() {
  while (this.length > 0) {
    this.pop();
  }
};

function walkRec( entry, childProp, fn )
{
  if(entry[childProp] && entry[childProp].length){
    for(var i =  0; i < entry[childProp].length; i++)
    {
      if(entry[childProp][i] )
      {
        walkRec( entry[childProp][i], childProp, fn );
      }
    }
  }
  fn( entry );
}
function walkRoomRec( entry, childProp, fn )
{
  if(entry[childProp] && entry[childProp].length){
    for(var i =  0; i < entry[childProp].length; i++)
    {
      if(entry[childProp][i] )
      {
        walkRec( entry[childProp][i] , childProp, fn );
      }
    }
  }
  fn( entry );
}

Array.prototype.walkUp = function(fn,sf){
  var b;
  if(this.length > 0)
  {
    var i = 0;
    while(i < this.length)
    {
      var o = this[i];
      b = fn(o,i);
      if(b != undefined) {i= this.length;};
      i++;
    }
  }
  if(sf){sf();}
  return  b != undefined  ? b : this ;
};

Array.prototype.walk = function(fn,sf){
  return this.walkUp(fn,sf);

};

Array.prototype.walkDown = function(fn,sf){
  var b;
  if(this.length > 0)
  {
    var i = this.length-1;
    while(i >= 0)
    {
      var o = this[i];
      b = fn(o,i);
      if(b) return b;
      i--;
    }
  }
  if(sf){sf();}
  return b != undefined ? b : this ;
};
Array.prototype.walkFor = function(fn,sf){

    for(var key in this)
    {
      if(this.hasOwnProperty(key))
      fn( key , this[key] );
    }

  if(sf){sf();}
  return  this ;
};

Number.prototype.pad = function(size) {
      var s = String(this);
      while (s.length < (size || 2)) {s = "0" + s;}
      return s;
  };
function padZero(s)
      {
        return (s.length < 2) ? "0" + s : s;
      }

      // -------------------------------------------//
     //               Deep Array copy              //
    // -------------------------------------------//
function deepCopy(from, to,withProps)
{
    if (from == null || typeof from != "object") return from;
    if (from.constructor != Object && from.constructor != Array) return from;
    if (from.constructor == Date || from.constructor == RegExp || from.constructor == Function ||
        from.constructor == String || from.constructor == Number || from.constructor == Boolean)
        return new from.constructor(from);

    to = to || new from.constructor();

    for (var name in from)
    {
        if(from.hasOwnProperty ( name ) || (withProps != undefined || withProps == false))
        {
         to[name] = typeof to[name] == "undefined" ? deepCopy( from[name] , null) : to[name];
        }
    }

    return to;
}




      // -------------------------------------------//
     //       indexOf for downcompatibly           //
    // -------------------------------------------//

var indexOf = function(needle) {
    if(typeof Array.prototype.indexOf === 'function') {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function(needle) {
            var i = -1, index = -1;

            for(i = 0; i < this.length; i++) {
                if(this[i] === needle) {
                    index = i;
                    break;
                }
            }

            return index;
        };
    }

    return indexOf.call(this, needle);
};

      // -------------------------------------------//
     //               Debug Function               //
    // -------------------------------------------//




Array.prototype.compare = function (array) {
    // if the other array is a falsy value, return
    if (!array)
        return false;

    // compare lengths - can save a lot of time
    if (this.length != array.length)
        return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].compare(array[i]))
                return false;
        }
        else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
};

/* Object.assign() polyfill for IE11. */
if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target === null || target === undefined) {
          throw new TypeError('Cannot convert undefined or null to object');
        }
  
        var to = Object(target);
  
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
  
          if (nextSource !== null && nextSource !== undefined) { 
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
}

/* Object.entries polyfill for IE11, Edges 12 and 13 and older Safaris. */
if (!Object.entries) {
    Object.entries = function( obj ){
      var ownProps = Object.keys( obj ),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array
      while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      
      return resArray;
    };
  }
  

/* Number.isNaN polyfill for IE11. */
Number.isNaN = Number.isNaN || function(value) {
    return value !== value;
};

/* Number.isInteger polyfill for IE11. */
Number.isInteger = Number.isInteger || function(value) {
    return (typeof value === 'number'
            && isFinite(value)
            && Math.floor(value) === value);
};

/* String.prototype.includes polyfill for IE11. */
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

/* Array.prototype.includes polyfill for IE11 and Edges 12 and 13. */
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, "includes", {
        value: function (searchElement, fromIndex) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return (
                    x === y ||
                    (typeof x === "number" &&
                        typeof y === "number" &&
                        isNaN(x) &&
                        isNaN(y))
                );
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                // c. Increase k by 1.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                k++;
            }

            // 8. Return false
            return false;
        },
    });
}

/* Array.prototype.find polyfill for IE11 and Edges 12 - 14. */
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, "find", {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== "function") {
                throw TypeError("predicate must be a function");
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        },
        configurable: true,
        writable: true,
    });
}

/* Array.prototype.find polyfill for IE11 and Edges 12 - 14. */
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
      value: function(predicate) {
       // 1. Let O be ? ToObject(this value).
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }
  
        var o = Object(this);
  
        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;
  
        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }
  
        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];
  
        // 5. Let k be 0.
        var k = 0;
  
        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return k.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return k;
          }
          // e. Increase k by 1.
          k++;
        }
  
        // 7. Return -1.
        return -1;
      },
      configurable: true,
      writable: true
    });
  }

/* String.prototype.startsWith polyfill for IE11. */
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
            var pos = rawPos > 0 ? rawPos|0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

